export const { REACT_APP_SERVER_URL } = process.env
